import { getCategoriesAction } from '~/api/functions/categories/get-categories.action'
import type { Category } from '~/api/typings'

// Fetch Popular Services
export function useCategories() {
  /**
   * Fetch categories with SSR support.
   */
  const {
    data: categories,
    pending: loadingCategories,
    error: categoriesError,
    refresh: refreshCategories,
  } = useAsyncData('categories', () => getCategoriesAction(), {
    transform: (res) => res?.data ?? [],
    default: () => [] as Category[],
  })

  return {
    // Categories
    categories,
    loadingCategories,
    categoriesError,
    refreshCategories,
  }
}
